export const moduleName = 'organisations'

type BaseOrganisationRequestPayload = {
  name: string
  team_size?: number
  contact_name?: string
  email?: string
  phone_number?: string
  domain?: string
  country_calling_code?: string
  website_url?: string
  logo?: string
  associated_email_domains?: string[]
  associated_emails?: string[]
  paying_corporate_partner?: false
  earns_team_size_trees_monthly?: false
  invite_code_email_reminders_enabled?: true
  country_code?: string
  flat_number?: string
  building_number?: string
  building_name?: string
  street?: string
  sub_street?: string
  town?: string
  postcode?: string
  area?: string
  region?: string
}

export type CreateOrganisationRequestPayload = BaseOrganisationRequestPayload & {
  hubspot_id: number
  paying_corporate_partner: true
  team_size: number
  country_code: string
}

export type CreateCharityRequestPayload = BaseOrganisationRequestPayload

export type CreateOrganisationResponse = {
  id: string
  created_on: string
  updated_on: string
  flat_number: string
  building_number: string
  building_name: string
  street: string
  sub_street: string
  town: string
  postcode: string
  area: string
  region: string
  country_code: string
  name: string
  logo: string
  domain: string
  invite_code_email_reminders_enabled: boolean
}

export type CreateOrganisationNormalisedResponse = {
  id: string
  name: string
}
